import { Configuration } from "@nestcoinco/hyper-api-gateway-api-client";

export const platformType = process.env.REACT_APP_PLATFORM_TYPE || "HYP";

const apiConfig = new Configuration({
  basePath: process.env.REACT_APP_API_BASE_PATH,
});

export default apiConfig;
